import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
const ContactSection = () => {
  return <div className="bg-navy-50 py-16" data-id="element-270">
      <div className="container mx-auto px-4 md:px-8" data-id="element-271">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-navy-900 mb-10" data-id="element-272">
          ONE CALL Away!
        </h2>
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-10" data-id="element-273">
          <a href="https://wa.me/6592285757" target="_blank" rel="noopener noreferrer" className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-md font-medium transition-colors flex items-center justify-center w-full md:w-auto" data-id="element-274">
            <MessageCircle size={24} className="mr-2" data-id="element-275" />
            TEXT US! 9228 5757
          </a>
          <a href="tel:+6567213357" className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-md font-medium transition-colors flex items-center justify-center w-full md:w-auto" data-id="element-276">
            <Phone size={24} className="mr-2" data-id="element-277" />
            CALL US! 6721 3357
          </a>
        </div>
        <div className="mt-10 text-center text-navy-700" data-id="element-278">
          <p data-id="element-279">Our travel experts are ready to assist you with any inquiries</p>
        </div>
      </div>
    </div>;
};
export default ContactSection;